export default "__VITE_ASSET__BB0Zkcp4__"